import React from 'react';

import {SchemaTag} from 'folder-items/FileConstants';
import {ElementKeyboardEvent} from 'util/Types';

import NumericValueEditor from './NumericValueEditor';

interface IntegerValueEditorProps {
  autoFocus: boolean;
  defaultValue?: SchemaTag;
  onChange: (value: {integerValue: number | null; value: string}) => void;
  onKeyDown?: (e: ElementKeyboardEvent) => void;
  placeholder?: string;
  useStringValue?: boolean;
  isDisabled?: boolean;
}

export default function IntegerValueEditor(props: IntegerValueEditorProps): JSX.Element {
  return (
    <NumericValueEditor
      placeholder={props.placeholder}
      valueAccessorKey="integerValue"
      validateInteger={true}
      {...props}
    />
  );
}

IntegerValueEditor.defaultProps = {
  placeholder: 'Integer Value',
};
